import { IdCodeLibelle } from '../../id-code-libelle.abstract.model';

export class StatutManquement extends IdCodeLibelle {}
